import React from "react";
import Chart from "react-apexcharts";
import ChartCard from "./ChartCard";
import { baseChartOptions } from "./chartTheme";

const CHART_ID = "slope-chart";

interface SlopeChartProps {
  labels?: string[];
  data1?: number[];
  data2?: number[];
  label1?: string;
  label2?: string;
}

const SlopeChart: React.FC<SlopeChartProps> = ({
  labels = [],
  data1 = [],
  data2 = [],
  label1 = "Total Cases",
  label2 = "Executed Cases",
}) => {
  const safeLabels = labels.length > 0 ? labels : ["Week 1"];
  const safeData1 = data1.length > 0 ? data1 : [0];
  const safeData2 = data2.length > 0 ? data2 : [0];

  const base = baseChartOptions(CHART_ID);
  const options = {
    ...base,
    chart: { ...base.chart, type: "line" },
    colors: ["#E9672D", "#7c3aed"],
    xaxis: { categories: safeLabels },
    stroke: { curve: "smooth", width: 3 },
    markers: { size: 3, hover: { size: 5 } },
  };

  const series = [
    { name: label1, data: safeData1 },
    { name: label2, data: safeData2 },
  ];

  return (
    <ChartCard
      title="Total vs Executed Cases Trend"
      description="Compares the weekly trend of total cases to executed cases."
      chartId={CHART_ID}
    >
      <Chart options={options} series={series} type="line" height={300} />
    </ChartCard>
  );
};

export default SlopeChart;
